<main class="account-page">
  <section class="account-card">
    <p class="eyebrow">Account Access</p>
    <h1>Log in to Hebern</h1>
    <p class="lede">
      Manage your account, plan, password, and API access from one place.
    </p>

    <form [formGroup]="form" (ngSubmit)="submit()" class="account-form">
      <label>
        <span>Email</span>
        <input
          type="email"
          formControlName="email"
          autocomplete="email"
          placeholder="you@example.com"
        />
        @if (form.controls.email.invalid && form.controls.email.touched) {
        <small>Please enter a valid email.</small>
        }
      </label>

      <label>
        <span>Password</span>
        <input
          type="password"
          formControlName="password"
          autocomplete="current-password"
          placeholder="Your password"
        />
        @if (form.controls.password.invalid && form.controls.password.touched) {
        <small>Password must be at least 8 characters.</small>
        }
      </label>

      @if (errorMessage) {
      <div class="form-alert form-alert--error">{{ errorMessage }}</div>
      }

      <button type="submit" class="primary-action" [disabled]="isLoading">
        {{ isLoading ? 'Logging in...' : 'Log In' }}
      </button>
    </form>

    <div class="account-links">
      <a routerLink="/account/signup">Create an account</a>
      <span aria-hidden="true">|</span>
      <a routerLink="/forgot-password">Forgot password?</a>
    </div>
  </section>
</main>
